var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.833,
    height: 17.833,
    viewBox: "0 0 17.833 17.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_candidato",
    "data-name": "icona candidato",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_294",
    "data-name": "Tracciato 294",
    d: "M15.221,11.528A8.882,8.882,0,0,0,11.833,9.4,5.155,5.155,0,1,0,6,9.4a8.931,8.931,0,0,0-6,8.43H1.393a7.523,7.523,0,1,1,15.047,0h1.393A8.858,8.858,0,0,0,15.221,11.528Zm-6.3-2.612a3.762,3.762,0,1,1,3.762-3.762A3.766,3.766,0,0,1,8.916,8.917Z",
    transform: "translate(7 7)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameTitle);
export default __webpack_public_path__ + "static/media/name_title.aaf7b11bae3bbb1eb8da7ad9bfc39c69.svg";
export { ForwardRef as ReactComponent };